import { ActionType } from '@/constants';
import type { OrderPayload } from '@/types';
import type { Action } from './types';

export const orderPayloadReducer = (state: OrderPayload, action: Action) => {
  if (action.type === ActionType.SetBillingAddress) {
    return {
      ...state,
      billingAddress: {
        ...state.billingAddress,
        ...action.payload,
      },
    };
  }

  if (action.type === ActionType.SetClickAndCollectStoreId) {
    return {
      ...state,
      clickAndCollectStoreId: action.payload,
    };
  }

  if (action.type === ActionType.SetDeliveryAddress) {
    return {
      ...state,
      shippingAddress: {
        ...state.shippingAddress,
        ...action.payload,
      },
    };
  }

  if (action.type === ActionType.SetDeliveryMethod) {
    return { ...state, deliveryMethod: action.payload };
  }

  if (action.type === ActionType.SetDeliveryOption) {
    return { ...state, deliveryOption: action.payload };
  }

  if (action.type === ActionType.SetEmail) {
    return { ...state, email: action.payload };
  }

  if (action.type === ActionType.SetGiftMessage) {
    return { ...state, giftMessage: action.payload };
  }

  if (action.type === ActionType.SetIsGift) {
    return { ...state, isGift: action.payload };
  }

  if (action.type === ActionType.SetMarketingOptIn) {
    return { ...state, emailOptInNewsAndOffers: action.payload };
  }

  const _exhaustiveCheck: never = action;
  throw new Error(`Unknown action: ${JSON.stringify(_exhaustiveCheck)}`);
};
